import styles from "./ButtonGroup.module.scss";

interface IButtonGroupProps {
    children: React.ReactNode;
    /**
     * @default "md"
     */
    spacing?: "none" | "sm" | "md" | "lg";
}

const styleMapper = {
    "none": styles.none,
    "sm": styles.small,
    "md": styles.medium,
    "lg": styles.full
};

/**
 * A component that groups multiple buttns inline
 * @param children The list of the buttons to render inside the group
 * @param spacing The spacing between each button
 * @returns JSX.Element
 */
function ButtonGroup({ children, spacing = "sm" }: IButtonGroupProps): JSX.Element {
    return (
        <div className={`${styles.buttonGroupContainer} ${spacing ? styleMapper[spacing] ?? "" : ""}`}>
            {children}
        </div>
    );
}

export default ButtonGroup;
